import script from "./SurveyNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyNavigation.vue?vue&type=script&setup=true&lang=js"

import "./SurveyNavigation.vue?vue&type=style&index=0&id=744a86ba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-744a86ba"]])

export default __exports__